import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { History } from 'history';
import { Menu, message, Divider, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { ClickParam } from 'antd/lib/menu';
import { FaCog, FaSignOutAlt, FaCreditCard } from 'react-icons/fa';
import { getUserState } from '../../../store/user/selector';
import { logoutuser } from '../../../store/user/actions';

import HatIcon from '../../../assets/images/png/nav/newhat.png';

const COOK = 'i offer';
const GUEST = 'i seek';

export const ProfileMenu: React.FC = () => {
  const { user } = useSelector(getUserState);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history: History = useHistory();

  const handleMenuClick = (e: ClickParam): void => {
    switch (e.key) {
      case 'bank':
        history.push('/bank/add');
        break;
      case 'settings':
        history.push('/settings');
        break;
      case 'about':
        history.push('settings/about');
        break;
      case 'logout':
        dispatch(logoutuser());
        message.info('Logged out');
        history.push('/dashboard');
        break;
      default:
      // console.log('');
    }
  };

  const validateUser = () => {
    if (user.userid && !user.authComplete) {
      history.push('/profile/create');
      return;
    }
  };

  useEffect(validateUser, [user]);
  return (
    <Menu
      selectable={false}
      mode="vertical"
      className="profile-menu-container"
      onClick={handleMenuClick}
    >
      <Menu.Divider className="profile-menu-divider" />
      {user.accountType === GUEST && (
        <Menu.Item key="payment">
          <Row className="item-menu-wrap">
            <FaCreditCard color="#27aae1" size={18} />
            <span>{t('Payment Card')}</span>
          </Row>
          <Divider />
        </Menu.Item>
      )}
      {user.accountType === COOK && (
        <Menu.Item key="bank">
          <Row className="item-menu-wrap">
            <FaCreditCard color="#27aae1" size={18} />
            <span>{t('BANK_ACCOUNT')}</span>
          </Row>
          <Divider />
        </Menu.Item>
      )}
      <Menu.Divider className="profile-menu-divider" />
      <Menu.Item key="settings">
        <Row className="item-menu-wrap">
          <FaCog color="#27aae1" size={18} />
          <span>{t('Settings')}</span>
        </Row>
        <Divider />
      </Menu.Item>
      <Menu.Divider className="profile-menu-divider" />

      {/* <Menu.Item key="share">
        <Row className="item-menu-wrap">
          <FaHeart color="#27aae1" size={18} />
          <span>{t('Share')} MyCookAround</span>
        </Row>
      </Menu.Item>
      <Menu.Divider className="profile-menu-divider" /> */}

      <Menu.Item key="about">
        <Row className="item-menu-wrap">
          <img src={HatIcon} alt="hat" />
          <span>{t('About Us')}</span>
        </Row>
      </Menu.Item>
      <Menu.Divider className="profile-menu-divider" />

      <Menu.Item key="logout">
        <Row className="item-menu-wrap">
          <FaSignOutAlt color="#27aae1" size={18} />
          <span>{t('Logout')}</span>
        </Row>
      </Menu.Item>
      <Menu.Divider className="profile-menu-divider" />
    </Menu>
  );
};
